import VueSlider from "vue-slider-component";

// Cant work with global Vue component, import vue twice instead.
window.VueSlider = VueSlider;